module.exports = __webpack_public_path__ + "img/84.8.TSS.b449baf2.png";